///<reference path="../../App/plugins/DefinitelyTyped/google.maps.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { MySharedService } from '../App/shared.service';

@Component({
    templateUrl: './AppViews/AttendanceMarking/groupAttendance.html'
})

export class GroupAttendanceComponent implements OnInit {

    public showDetail = false;
    public geoError: string = "";
    public timer: any;
    constant: Constants;
    attendanceItems: any = [];
    public attendanceModel: any = {};
    public geoLocationModel: any = {};
    teamItems: any[];
    siteItems: any[];
    userDetail: any;
    filter: any = { 'TeamId': '', 'SiteId': '' };
    Search: any = "";
    public TodayUTCDate: any;

    public showLoader = false;


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.attendanceModel.AttendanceId = 0;
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.constant = new Constants();
    }

    ngOnInit() {
        this.getServerUTCDate();
    }

    public getServerUTCDate() {
        this.showLoader = true;
        this._httpService.ajaxPost("Attendance/GetServerUTCDate").subscribe(
            data => {
                this.TodayUTCDate = data["TodayUTCDate"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.filter = { 'TeamId': '', 'Date': moment(this.TodayUTCDate).format('DD/MM/YYYY'), 'SiteId': '' };
                this.BindFilters();               
            }
        );

    }



    public MarkPresent(dt: any) {
        this.attendanceModel = JSON.parse(JSON.stringify(dt));
        if (this.attendanceModel.Date === moment(this.TodayUTCDate).format('DD/MM/YYYY')) {   // if mark attendance on today's date...         
            if (this.attendanceModel.IsTodayHoliday == true) {
                this.attendanceModel.StatusId = this.constant.enumAttendanceStatus["NotApproved"]; // if today is holiday then status should be Worked_on_Holiday 
            }
            else {
                this.attendanceModel.StatusId = this.constant.enumAttendanceStatus["Present"];  // if today is not holiday then direct status will be Present
            }
        }
        this.attendanceModel.IsPresent = true;
        this.attendanceModel.MarkedBy = this.userDetail.SiteUserId;
        this.SaveAttendance();
    }


    public SaveAttendance() {
        this.showLoader = true;
        this._httpService.ajaxPost("Attendance/AddUpdateAttendance", this.attendanceModel).subscribe(
            data => {
                this._sharedService.ShowMessage(data["Status"].Message);
            },
            err => {
                console.log("GetAttendance Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                $('#addAttendance').modal('hide');
                this.attendanceModel = { 'StatusId': '' };
                this.showLoader = false;
                this.GetAttendance();              
            });
    }

    public clearFilter() {
        this.filter = { 'TeamId': '', 'Date': moment(this.TodayUTCDate).format('DD/MM/YYYY'), 'SiteId': '' };
        this.Search = "";
    }

    public GetAttendance() {
        this.showLoader = true;
        var TeamId = this.filter.TeamId == "" ? this.userDetail.TeamID :this.filter.TeamId;
        
        this._httpService.ajaxPost("Attendance/GetAttendance", { 'TeamId': TeamId, 'SiteId': this.filter.SiteId, "Date": this.filter.Date, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.attendanceItems = data["Attendance"];
            },
            err => {
                console.log("GetAttendance Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);

            },
            () => {
                this.showLoader = false;
            }
        );
    }

    ngAfterViewInit() {
        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#show-filter").click(function () {
            $(".filter-form").slideToggle();           
        }).bind(this);

        $('[data-toggle=tooltip]').hover(function () {
            $(this).tooltip('show');
        }, function () {
            $(this).tooltip('hide');
        });
    }

    public BindFilters() {
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }     
        this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": userId }).subscribe(
            data => {
                this.teamItems = data["AssignedTeam"];
            },
            err => {
                console.log("BindFilters Failed");
                this.showLoader = false;
            },
            () => {
                this._httpService.ajaxPost("Common/GetSite").subscribe(
                    data => {
                        this.siteItems = data["Site"];
                    },
                    err => {
                        console.log("BindFilters Failed");
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;      
                        this.GetAttendance();                               
                     }
                );               
            }
        );
    }
}




/** WEBPACK FOOTER **
 ** ./TypeScripts/AttendanceMarking/groupAttendance.component.ts
 **/